@let isCustomDeleted = isDisabled() && getCustomValueState('id');

<mat-expansion-panel
  class="cta-expansion-panel"
  [class.analytics-mode-panel]="analyticsMode()"
  [class.view-mode]="isViewMode()"
  [disabled]="isCustomDeleted || analyticsMode()"
  [expanded]="(isPanelExpanded() && !isCustomDeleted) || analyticsMode()"
  [hideToggle]="analyticsMode()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title>
      <div class="flex flex-1 justify-between items-center">
        <div class="flex flex-grow flex-col mr-8">
          <div class="flex gap-2">
            <app-editable-title
              fontClasses="font-bold"
              [class.text-sm]="!analyticsMode()"
              [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
              [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
              [iconSize]="16"
              [subtitle]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.visualDeliverable.subtitle' | translate"
              [control]="name"
              [isViewMode]="isViewMode()"
              [disabled]="isCustomDeleted"
              [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
              [infoTooltip]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptions.visual' | translate"
              [creatorBriefingMode]="creatorBriefingMode()"
              [showRequiredBadge]="showRequiredBadge()"
            />

            @if (showSeparator()) {
              <hr class="flex-1 ml-2 pb-0.5 border border-shikenso-purple-base-12 self-center" />
            }
          </div>

          @if (description()) {
            <div class="text-xs">{{ description() }}</div>
          }
        </div>

        @if (!isViewMode()) {
          <div class="flex items-center gap-7">
            <app-deliverable-advanced-button
              [platformFeature]="platformFeature()"
              [deliverableType]="form().value.type"
              [isOpen]="showAdvancedSettings()"
              (toggled)="onToggleAdvancedSettings()"
            />

            <div class="flex items-center">
              @if (isCustomMode() && !form().value.exclusiveTo) {
                <app-custom-remove-button
                  [checked]="!getCustomValueState('id')"
                  (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                  #deleteParentButton
                />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-transparent-button-color"
                  (click)="onDeleteClick(form().value.exclusiveTo)"
                >
                  <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                </button>
              }
            </div>
          </div>
        }
      </div>
    </mat-panel-title>

    @if (isCustomDeleted) {
      <svg
        class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
      </svg>
    }
  </mat-expansion-panel-header>

  <div class="flex gap-3 custom-form" [formGroup]="form()">
    <div class="flex flex-1 items-center">
      <app-file-uploader
        #fileUploaderComponent
        class="w-full"
        size="big"
        [imageWidth]="60"
        [imageHeight]="60"
        [imageId]="form().get('imageId')?.value"
        [title]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.visualDeliverable.fileUploadTitle' | translate"
        [fileForm]="imageFile"
        [displayRevertButton]="
          getCustomValueState('imageId') && isCustomMode() && !form().value.exclusiveTo && !isViewMode()
        "
        [isExclusive]="form().value.exclusiveTo"
        [disabled]="isCustomDeleted && !isViewMode()"
        [isViewMode]="isViewMode()"
        [requiredPermission]="[EPermissions.campaignCreate]"
        (imageSelected)="onImageSelected($event)"
        (imageRemoved)="onImageRemoved()"
        (reverted)="onRevertToGlobalClick('imageId')"
      />
    </div>

    <div class="flex items-center gap-2">
      <mat-radio-group class="flex flex-col" formControlName="focus" labelPosition="before">
        <mat-radio-button [value]="EVisualFocus.mixed">
          {{
            'pages.campaignForm.ctaDialog.ctaDetails.deliverables.visualDeliverable.types.' + EVisualFocus.mixed
              | translate
          }}
        </mat-radio-button>
        <mat-radio-button [value]="EVisualFocus.graphic">
          {{
            'pages.campaignForm.ctaDialog.ctaDetails.deliverables.visualDeliverable.types.' + EVisualFocus.graphic
              | translate
          }}
        </mat-radio-button>
        <mat-radio-button [value]="EVisualFocus.text">
          {{
            'pages.campaignForm.ctaDialog.ctaDetails.deliverables.visualDeliverable.types.' + EVisualFocus.text
              | translate
          }}
        </mat-radio-button>
      </mat-radio-group>

      @if (isCustomMode() && !isViewMode() && getCustomValueState('focus') && !form().value.exclusiveTo) {
        <button
          mat-icon-button
          type="button"
          class="mat-secondary-transparent-button-color"
          [disabled]="isCustomDeleted"
          (click)="onRevertToGlobalClick('focus')"
        >
          <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
        </button>
      }
    </div>
  </div>

  @if (showAdvancedSettings() && !isViewMode()) {
    <div class="pl-3 mt-4">
      <app-deliverable-advanced-settings-section
        [form]="form()"
        [platformFeature]="platformFeature()"
        [deliverableType]="form().value.type"
        [isCustomMode]="isCustomMode()"
        [creatorId]="creatorId()"
      />
    </div>
  }
</mat-expansion-panel>
